<template lang="pug">
template(v-if="currentUser.isManager")
  RouterLink(
    v-if="showButton"
    :to=" '/tours/' + tour.id + '/schedule-email'"
    v-tooltip.top="tooltipText"
  )
    Button(
      v-bind="$attrs"
      :label="label"
      :severity="severity"
      icon="ph ph-bold ph-paper-plane-tilt"
      rounded
    )
template(v-else)
  Button(
    v-bind="$attrs"
    :label="label"
    :severity="severity"
    icon="ph ph-bold ph-paper-plane-tilt"
    rounded
  )  
</template>

<script setup>
import { computed } from 'vue'
import { format } from '@/utils'
import { useAuthStore } from "@/stores"

defineOptions({inheritAttrs: false})

const props = defineProps({
  tour:      { type: Object, default: {} },
  showLabel: { type: Boolean, default: true },
})

const { currentUser } = useAuthStore()

const showButton   = computed(() => props.tour.isScheduleable)
const emailStatus  = computed(() => props.tour.emailStatus)

const label = computed(() => {
  if (!props.showLabel) return null
  const status = emailStatus.value?.status
  if (status === 'sent')  return 'Sent'
  if (status === 'error') return 'Error'
  return 'Send'
})

const severity = computed(() => {
  const status = emailStatus.value?.status
  if (status === 'sent')  return 'secondary'
  if (status === 'error') return 'danger'
  return 'info'
})

const tooltipText = computed(() => {
  const s = emailStatus.value
  if (s?.status === 'sent') {
    return `Schedule Sent\n${format.dateLong(s.sentAt)}\n${format.dateToNow(s.sentAt)}`
  }
  if (s?.status === 'error') {
    return `Send failed: ${s.errorMessage}`
  }
  return null
})
</script>
